<template>
  <v-simple-table>
    <thead>
    <tr>
      <th style="width: 62px;">

      </th>
      <th>
        Name
      </th>
      <th>
        Tag Name
      </th>
      <th>
        Type
      </th>
      <th>
        Required
      </th>
      <th>
        Instructions
      </th>
      <th>
        Options
      </th>
    </tr>
    </thead>
    <draggable v-model="localTags"
               tag="tbody"
               handle=".handle"
               @end="endMove">
      <tr v-for="customTag in localTags"
          :key="customTag.id">
        <td>
          <v-icon class="handle"
                  style="cursor: grab;">
            fas fa-fw fa-grip-lines
          </v-icon>
        </td>
        <td>
          <a @click.prevent="editCustomTag(customTag)">
            {{ customTag.name }}
          </a>
        </td>
        <td>
          <code>
            {{ customTag.tag_name }}
          </code>
          <v-icon right
                  @click.prevent="copyText(customTag.tag_name)"
                  x-small>
            fal fa-fw fa-copy
          </v-icon>
        </td>
        <td>
          {{ customTag.tag_type }}
        </td>
        <td>
          {{ customTag.is_required ? 'Yes' : 'No' }}
        </td>
        <td>
          <div style="font-size: 0.75rem;">
            {{ customTag.instructions }}
          </div>
        </td>
        <td>
          <ul v-if="customTag.options?.length > 0"
              class="pl-4">
            <li v-for="option in customTag.options"
                :key="option.id"
                style="font-size: 0.75rem;">
              <template v-if="customTag.is_html">
                {{ option.name }}
              </template>
              <template v-else>
                {{ option.value }}
              </template>
            </li>
          </ul>
        </td>
      </tr>
    </draggable>
  </v-simple-table>
</template>
<script>
import draggable from 'vuedraggable';
import DOMPurify from 'dompurify';
import clipboardService from '../../../../../ml/services/clipboardService';

export default {
  components: {draggable},
  props: {
    customTags: {
      type: Array,
      required: true,
    },
    template: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localTags: this.customTags,
    }
  },
  methods: {
    async copyText(text) {
      await clipboardService.copy(text);
      this.$toast.success('Copied to clipboard.');
    },
    editCustomTag(customTag) {
      this.$emit('edit', customTag);
    },
    endMove() { // MLD-7077
      const tagIDs = this.localTags.map(tag => tag.id);
      const data = {
        tags: tagIDs,
      }
      axios.post(`/api/share-templates/${this.template.id}/custom-tags/reorder`, data)
        .then(response => {
          if (response.data.updated) {
            this.$toast.success('Custom tags reordered.');
            this.$emit('update');
          }
        })
        .catch(err => {
          if (err.response?.data?.error) {
            this.$toast.error(DOMPurify.sanitize(err.response?.data?.error));
          } else {
            this.$toast.error('An error occurred while reordering custom tags.');
          }
        })
    }
  }
}
</script>
